export default String.raw`
.newsletter {
    display: flex;
    align-items: center;
    margin: 0 auto;
    padding: 32px 9%;
    background-color: $newsletterBgColor;
    width: 100%;
    min-height: 288px;

    &__container {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: min-content auto;
        row-gap: 32px;
        column-gap: 24px;
        grid-template-areas: "h f"
                            "c f"
                            "c f";

        &-title {
            grid-area: h;
            display: flex;
            align-items: center;
            column-gap: 24px;
            width: 100%;
            
            svg {
                min-width: 52px;
                width: 52px;
                height: 52px;
                fill: $newsletterFont;
            }
            
            div {
                h3 {
                    margin-bottom: 8px;
                    color: $newsletterFont;
                }
            
                p {
                    @include body-1-regular;
                    color: $newsletterFont;
                }
            }
        }

        &-content {
            grid-area: c;

            &-icons {
                display: grid;
                grid-template-columns: auto auto;
                row-gap: 24px;

                div {
                    display: flex;
                    align-items: center;
                    column-gap: 16px;

                    svg {
                        width: 32px;
                        height: 32px;
                        fill: $newsletterFont;
                    }

                    span {
                        @include body-1-regular;
                        color: $newsletterFont;
                    }
                }
            }
        }

        &-form {
            padding: 16px 0;
            grid-area: f;
            display: flex;
            flex-direction: column;
            row-gap: 20px;

            &-info {
                display: none;
            }

            &-email {
                display: flex;
                align-items: center;
                position: relative;
                width: 100%;

                svg {
                    position: absolute;
                    width: 24px;
                    height: 24px;
                    fill: $bgColorFont;
                    left: 16px;
                }

                input {
                    width: 100%;
                    height: 40px;
                    padding: 0px 8px 0 48px;
                    border: 1px solid $bgColorFont;
                    border-radius: 5px;
                    @include body-1-regular;
                    background-color: $inputsBgColor;
                    color: $newsletterFont;
                }
            }

            &-buttons {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                gap: 16px;

                button {
                    min-width: 177px;
                    max-width: 177px;
                    padding: 8px 32px;
                    order: 2;
                }

                p {
                    width: 100%;
                    order: 3;
                    @include body-2-regular;
                    color: $newsletterFont;

                    a {
                        text-decoration: underline;
                        cursor: pointer;
                    }

                    &:first-child {
                        width: calc(100% - 193px);
                        order: 1;
                    }
                }

                div {
                    width: 100%;
                    order: 3;

                    &:first-child {
                        order: 1;
                        width: calc(100% - 193px);
                    }

                    label {
                        width: fit-content;
                        svg {
                            position: relative;
                            top: 1px;
                        }
    
                        span {
                            font-family: $fontFamily;
                            font-size: 12px;
                            font-weight: 400;
                            text-align: left;
                            color: $newsletterFont;
                        }
                    }
                }
            }
        }
    }
}
`